import classNames from "classnames"
import { SortableTableHeader } from "../../SortableTableHeader"
import Row from "./Row"
import { DesktopTableProps } from "./interfaces/DesktopTableProps"
import { displayDates } from "~/utils"

const DesktopTable = ({
  gridTemplateColumns,
  isMeterFieldsEditable,
  checkbox,
  toggleAll,
  checked,
  sortBy,
  setSortBy,
  isAscending,
  setIsAscending,
  isVisibleElectric,
  selectedFilterOption,
  rowItems,
  refreshLocalInvoices,
  selectedInvoiceIds,
  setSelectedInvoiceIds,
  isPendingSaveElectric,
  setSelectedInvoice,
  rowItemsData,
  isForPrint,
  startDate,
  endDate,
  selectedFilterBy,
}: DesktopTableProps) => {
  return (
    <>
      {isForPrint && (
        <div className="text-xl font-bold text-center my-4 text-black">
          {displayDates(startDate, endDate)} Filter by {selectedFilterBy}
        </div>
      )}
      <div
        className={classNames(
          !isForPrint ? "overflow-x-scroll 2xl:overflow-visible" : "overflow-visible",
          " max-w-full whitespace-nowrap",
        )}
        style={{
          maxWidth: !isForPrint && "95vw",
        }}
      >
        <div
          className="grid w-full border-b border-gray-300 sticky 2xl:top-[60px] bg-white z-9"
          style={{
            minWidth: window.screen.width < 1536 ? 1000 : "100%",
          }}
        >
          <div
            className="grid  w-full border-b border-gray-300 sticky 2xl:top-[86px] bg-white z-9"
            style={{
              gridTemplateColumns,
            }}
          >
            <div className="flex justify-center items-center">
              {!isMeterFieldsEditable && !isForPrint && (
                <input
                  type="checkbox"
                  className="hover:bg-gray-100 hover:cursor-pointer hover:border-gray-400 h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-green-600"
                  ref={checkbox}
                  onChange={toggleAll}
                  checked={checked}
                />
              )}
            </div>
            <div className="pr-3 py-3.5 text-left text-sm font-semibold text-gray-900">Amount</div>
            <div className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Status</div>
            <SortableTableHeader
              field="kind"
              sortBy={sortBy}
              setSortBy={setSortBy}
              isAscending={isAscending}
              setIsAscending={setIsAscending}
              isTable={false}
            >
              Kind
            </SortableTableHeader>
            <SortableTableHeader
              field="site"
              sortBy={sortBy}
              setSortBy={setSortBy}
              isAscending={isAscending}
              setIsAscending={setIsAscending}
              isTable={false}
            >
              Site
            </SortableTableHeader>
            <SortableTableHeader
              field="name"
              sortBy={sortBy}
              setSortBy={setSortBy}
              isAscending={isAscending}
              setIsAscending={setIsAscending}
              isTable={false}
            >
              Reservation
            </SortableTableHeader>
            <div className={classNames("min-w-[12rem] py-3.5 pr-3 text-sm font-semibold text-gray-900")}>Send Date</div>
            <SortableTableHeader
              field="due_date"
              sortBy={sortBy}
              setSortBy={setSortBy}
              isAscending={isAscending}
              setIsAscending={setIsAscending}
              isTable={false}
            >
              Due date
            </SortableTableHeader>

            {isVisibleElectric && (
              <>
                <div className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                  Last meter (kWh)
                </div>
                <div className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                  Current meter (kWh)
                </div>
                <div className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                  Electric used (kWh)
                </div>
                <div className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                  Electric subtotal
                </div>
              </>
            )}
            <div className="relative py-3.5 pl-3 pr-4 sm:pr-3">
              <span className="sr-only">Edit</span>
            </div>
          </div>
          {rowItems.length === 0 ? (
            <div className="flex justify-center py-24 w-full text-lg italic text-gray-400">
              <div>
                There are no{" "}
                {selectedFilterOption.label == "All invoices"
                  ? "invoices for the selected dates"
                  : selectedFilterOption.label.toLowerCase() + " invoices for the selected dates"}
              </div>
            </div>
          ) : (
            rowItems.map((item, index) => {
              return (
                <Row
                  gridTemplateColumns={gridTemplateColumns}
                  key={item.invoiceId || item.siteId}
                  rowItem={item}
                  refreshLocalInvoices={refreshLocalInvoices}
                  index={index}
                  isSelected={selectedInvoiceIds.includes(item.invoiceId)}
                  setIsSelected={(inv, isSelected) => {
                    !isMeterFieldsEditable &&
                      setSelectedInvoiceIds(
                        isSelected ? [...selectedInvoiceIds, inv.id] : selectedInvoiceIds.filter((id) => id !== inv.id),
                      )
                  }}
                  isLoadingSync={isPendingSaveElectric}
                  setSelectedInvoice={setSelectedInvoice}
                  isVisibleElectric={isVisibleElectric}
                  isMeterFieldsEditable={isMeterFieldsEditable}
                  rowItemData={rowItemsData?.find((rowItem) => rowItem.thisIndex === index)}
                  isForPrint={isForPrint}
                />
              )
            })
          )}
        </div>
      </div>
    </>
  )
}

export default DesktopTable
